import PropTypes from 'prop-types';

export const SURVEY_EDITOR__PATCH = 'SURVEY_EDITOR__PATCH';
export const SURVEY_EDITOR__RESET = 'SURVEY_EDITOR__RESET';
export const SURVEY_EDITOR__RESET_PAGE_RELOAD_MODAL = 'SURVEY_EDITOR__RESET_PAGE_RELOAD_MODAL';

export const SURVEY_EDITOR__LEFT_COL_WIDTH = '300px';
export const SURVEY_EDITOR__RIGHT_COL_WIDTH = '350px';

export const SURVEY_EDITOR__SHAPE_ERROR = PropTypes.shape({
  id: PropTypes.string,
  pageId: PropTypes.string,
  type: PropTypes.string,
});

export const SURVEY_EDITOR__ERROR_ARRAY = PropTypes.arrayOf(SURVEY_EDITOR__SHAPE_ERROR);

export const SURVEY_EDITOR__SHAPE = PropTypes.shape({
  reviewErrors: PropTypes.arrayOf(SURVEY_EDITOR__SHAPE_ERROR),
  selectedElement: PropTypes.string,
  selectedPage: PropTypes.string,
  selectedTab: PropTypes.number,
  showPublishModal: PropTypes.bool,
  showShareModal: PropTypes.bool,
  showVersionsModal: PropTypes.bool,
  totalResearchers: PropTypes.number,
  totalSurveys: PropTypes.number,
  updateThumbnails: PropTypes.number,
});
